import {
  BillingPaymentScheduleType,
  BillingStatus,
  IBilling,
  IBillingLocationIncreaseComparison,
  IBillingPaymentSchedule,
  IBillingWeighted,
} from "../types/billings";

export const defaultBillingWeighted: IBillingWeighted = {
  rate: 0,
  flatFee: 0,
  avgPublicWastePerPerson: 0,
  suggestedFlatFee: 0,
  suggestedRate: 0,
  lastYearsWasteSum: 0,
  minWastePerHousehold: 0,
  medianWastePerHousehold: 0,
};

export const defaultBillingLocationIncreaseComparison: IBillingLocationIncreaseComparison = {
  negative25: 0,
  negative20To25: 0,
  negative15To20: 0,
  negative10To15: 0,
  negative5To10: 0,
  negative0To5: 0,
  positive0To5: 0,
  positive5To10: 0,
  positive10To15: 0,
  positive15To20: 0,
  positive20To25: 0,
  positive25: 0,
};

export const createDefaultBillingPaymentSchedule = (year: number): IBillingPaymentSchedule => {
  return {
    annualDueDate: new Date(year, 11, 1).toISOString(),
    q1DueDate: new Date(year, 2, 31).toISOString(),
    q2DueDate: new Date(year, 5, 30).toISOString(),
    q3DueDate: new Date(year, 8, 30).toISOString(),
    q4DueDate: new Date(year, 11, 31).toISOString(),
    type: BillingPaymentScheduleType.Annual,
  };
};

export const defaultBilling: IBilling = {
  billingId: 0,
  year: 0,
  expectedWasteAmount: "",
  expectedExpenseSummary: 0,
  wasteAmount: "",
  expenseSummary: 0,
  submitted: false,
  balance: 0,
  status: BillingStatus.New,
  totalFeeSum: 0,
  totalNetFeeSum: 0,
  expenses: [],
  householdMemberSum: 0,
  totalCollectedFeeSum: 0,
  avgHouseholdFee: 0,
  avgResidentFee: 0,
  avgHouseholdFeeIncrease: null,
  avgResidentFeeIncrease: null,
  householdCount: 0,
  householdWithFixedOnlyCount: 0,
  weighted: structuredClone(defaultBillingWeighted),
  locationIncreaseComparison: structuredClone(defaultBillingLocationIncreaseComparison),
  paymentSchedule: createDefaultBillingPaymentSchedule(new Date().getFullYear()),
  removeExpenseApiIds: [],
  hasBeenSaved: false,
};

export const BILLING_EXPENSE_NAME_MAX_LENGTH = 200;
export const BILLING_EXPENSE_VALUE_MAX = 999_999_999;
export const BILLING_EXPENSE_VALUE_MIN = -999_999_999;
export const BILLING_EXPENSE_VALUE_STEP = 0.01;

export const MIN_BILLING_YEAR = 2020;

export const BILLING_WEIGHTED_FLAT_FEE_MIN = 0;
export const BILLING_WEIGHTED_FLAT_FEE_MAX = 100;
export const BILLING_WEIGHTED_FLAT_FEE_MAX_DECIMAL_PLACES = 2;

export const BILLING_WEIGHTED_RATE_MIN = 0;
export const BILLING_WEIGHTED_RATE_MAX = 0.2;
export const BILLING_WEIGHTED_RATE_MAX_DECIMAL_PLACES = 2;

export const BILLING_WEIGHTED_MIN_WASTE_PER_HOUSEHOLD_MIN = 0;
export const BILLING_WEIGHTED_MIN_WASTE_PER_HOUSEHOLD_MAX = 1000;
export const BILLING_WEIGHTED_MIN_WASTE_PER_HOUSEHOLD_OFFSET = 100;
export const BILLING_WEIGHTED_MIN_WASTE_PER_HOUSEHOLD_MAX_DECIMAL_PLACES = 0;
